import { render, staticRenderFns } from "./VesselAdministration.vue?vue&type=template&id=60e7fb63&"
import script from "./VesselAdministration.vue?vue&type=script&lang=ts&"
export * from "./VesselAdministration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports